import { InjectionToken } from '@angular/core';

export const SCOPE_KEY = new InjectionToken<string>('SCOPE_KEY');



// WEBPACK FOOTER //
// ./src/app/core/tokens.ts